import { audit, logoffAudit } from './audit-api';
import * as TYPES from './audit-actiontypes';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';

export const LOCAL_STORAGE_KEY = 'patient:audit';

const auditSuccessActionCreator = (type, patientId) => {
  const state = {
    auditState: 'success',
    auditType: type,
    patientId,
  };

  return {
    type: TYPES.AUDIT_SUCCESS,
    state,
  };
};

const auditFailureActionCreator = (type, patientId) => {
  const state = {
    auditState: 'failure',
    auditType: type,
    patientId,
  };

  return {
    type: TYPES.AUDIT_FAILURE,
    state,
  };
};

const auditRequestActionCreator = (type, patientId) => {
  const state = {
    auditState: 'request',
    auditType: type,
    patientId,
  };

  return {
    type: TYPES.AUDIT_REQUEST,
    state,
  };
};

export const auditRequest = (type, patientId, extraParameters) => (dispatch, getState) => {
  dispatch(auditRequestActionCreator(type, patientId));

  return audit(type, getState().profile.user.userId, patientId, extraParameters)
    .then(
      () => dispatch(auditSuccessActionCreator(type, patientId)),
      () => {
        dispatch(MsgBarActions.showErrorMessage());
        dispatch(auditFailureActionCreator(type, patientId));
      }
    );
};

export const logoffAuditRequest = (type, patientId) => (dispatch, getState) => {
  dispatch(auditRequestActionCreator(type));
  const state = getState();
  return logoffAudit(type, state.profile.user.userId, patientId)
    .then(
      () => dispatch(auditSuccessActionCreator(type, patientId)),
      () => {
        dispatch(MsgBarActions.showErrorMessage());
        dispatch(auditFailureActionCreator(type, patientId));
      }
    );
};